import PageLayout from '../components/layout/PageLayout'
import UnitsList from 'components/lists/units/UnitsList'

export default function UnitsPage() {
  return (
    <PageLayout pageTitle='Unidades de Medida' pageDesc='Altas, bajas y modificaciones.'>
      <UnitsList/>
    </PageLayout>
  )
}